// outros imports
import Picker from 'vanilla-picker';

function configPicker() {
	// Create a new Picker instance and set the parent element.
	// By default, the color picker is a popup which appears when you click the parent.
	let $pickers = $('.js-color-picker').parent();
	$('.js-color-picker').wrap('<div class="color-picker-wrap">');

	$pickers.each(function() {
		let $parent = $(this).find('.color-picker-wrap');
		let $el = $(this).find('input');
		let picker = new Picker({
			parent: this,
			popup: 'bottom',
			alpha: false
		});

		let useColor = $el.val();
		$parent.attr('style', '--color-picker-color: #' + useColor);

		picker.onOpen = function() {
			this.setColor('#' + useColor);
		}

		picker.onChange = function(color) {
			let useColor = color.hex.replace(/#/, '');
			useColor = useColor.substring(0,6);

			$el.val(useColor);
			$parent.attr('style', '--color-picker-color: #' + useColor);
		};
	});
}

export default configPicker;
